import { createBrowserRouter, Outlet, RouterProvider } from 'react-router-dom';
import { DesktopLayout } from './layouts/DesktopLayout';
import { EventsList } from './features/events/EventsList';
import { EventDetail } from './features/events/EventDetail';
import { DraftEditor } from './features/drafts/DraftEditor';
import { UploadPage } from './features/upload/UploadPage';
import { QuickPost } from './features/quick-post/QuickPost';
import { BrandSettings } from './features/brand/BrandSettings';
import { CalendarPage } from './features/calendar/CalendarPage';
import { AnalyticsPage } from './features/analytics/AnalyticsPage';
import { PeopleList } from './features/people/PeopleList';
import { CardManager } from './features/cards/CardManager';
import { KnowledgeSearch } from './features/knowledge-base/KnowledgeSearch';
import { CampaignPage } from './features/campaigns/CampaignPage';
import { ContentMapPage } from './features/content-map/ContentMapPage';
import { useTranslation } from './i18n';

function PlaceholderPage({ titleKey }) {
  const { t } = useTranslation();
  return (
    <article className="placeholder">
      <h1>{t(titleKey)}</h1>
      <p>{t('common.comingSoon')}</p>
    </article>
  );
}

// Wrapper so the layout sits inside the data router (required for useBlocker).
function RootLayout() {
  return (
    <DesktopLayout>
      <Outlet />
    </DesktopLayout>
  );
}

const router = createBrowserRouter([
  {
    path: '/',
    element: <RootLayout />,
    children: [
      { index: true,                  element: <EventsList /> },
      { path: 'upload',               element: <UploadPage /> },
      { path: 'quick-post',           element: <QuickPost /> },
      { path: 'calendar',             element: <CalendarPage /> },
      { path: 'content-map',          element: <ContentMapPage /> },
      { path: 'campaigns',            element: <CampaignPage /> },
      { path: 'brand',                element: <BrandSettings /> },
      { path: 'analytics',            element: <AnalyticsPage /> },
      { path: 'people',               element: <PeopleList /> },
      { path: 'cards',                element: <CardManager /> },
      { path: 'knowledge',            element: <KnowledgeSearch /> },
      { path: 'events/:eventId',      element: <EventDetail /> },
      { path: 'drafts/:draftId',      element: <DraftEditor /> },
      { path: '*',                    element: <PlaceholderPage titleKey="common.notFound" /> },
    ],
  },
]);

export default function App() {
  return <RouterProvider router={router} />;
}
